'use client'
import { StorageService } from '@dynamic-labs/utils';
import { CONNECTED_WALLETS_INFO } from '../../../../utils/constants/localStorage.js';

const clearExpiredData = (store) => {
    const { projectSettings, user } = store.getState();
    // TODO: we can clean this up once we move wallet info to the store
    const [connectedWalletData] = StorageService.getItem(CONNECTED_WALLETS_INFO) || [];
    const shouldRemoveSettingsAndConfigs = !user && !connectedWalletData;
    const isExpired = (value) => shouldRemoveSettingsAndConfigs ||
        (value.expiresAt && value.expiresAt < Date.now());
    if (isExpired(projectSettings)) {
        store.setState({
            projectSettings: store.getInitialState().projectSettings,
        });
    }
    return store;
};

export { clearExpiredData };
